export const AVATARS = [
  // Savannah & jungle
  '🦒', '🦛', '🐘', '🦓', '🦏', '🦁', '🐯', '🐆', '🦍', '🦧', '🐒', '🐵',
  '🐊', '🦜', '🦚', '🐍',
  // Forest & mountains
  '🦊', '🐻', '🐼', '🐨', '🐺', '🐗', '🦌', '🦬', '🦫', '🦝', '🦡', '🦨',
  '🦔', '🐿️', '🦉', '🦅',
  // Farm & home
  '🐮', '🐷', '🐔', '🦆', '🦢', '🐴', '🦙', '🐫', '🐰', '🐹', '🐱', '🐶',
  // Sea & ice
  '🐳', '🐬', '🦭', '🦈', '🐙', '🦀', '🦞', '🐡', '🐧', '🐢', '🦦', '🦩',
  // Small & odd
  '🐸', '🦋', '🐝', '🐞', '🐌', '🦥', '🦘', '🦄', '🦖', '🦕', '🐲',
  // Travel
  '🧭', '🗿', '🎒', '🏔️', '🌋', '🏝️', '🌵', '🍄', '🚲', '🛶', '🚀', '🛸',
] as const;

export type Avatar = (typeof AVATARS)[number];

/** Distinct colors used to tell players apart on result maps. */
export const PLAYER_COLORS = [
  '#FF6A4D', '#3DDC97', '#5AA9FF', '#FFC94A', '#C77DFF', '#FF7EB6', '#2ED3D9', '#A3E048',
  '#FF9F43', '#7C8CFF', '#F25F5C', '#4ECDC4', '#E9C46A', '#B388EB', '#06D6A0', '#EF476F',
  '#118AB2', '#FFD166', '#8AC926', '#F78C6B',
] as const;

export function randomAvatar(): Avatar {
  return AVATARS[Math.floor(Math.random() * AVATARS.length)]!;
}
